import React from 'react';

export default props => (
  <ul>
    {props.auditReport.map(item => (
      <li key={item.id}>
        {item.label}: <strong>{item.value}</strong>
      </li>
    ))}
  </ul>
);



// WEBPACK FOOTER //
// ./src/components/orders/AuditReport.js